import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e3779ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "whole-dashboard" }
const _hoisted_2 = { class: "admin-dashboard" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Admin Dashboard", -1))
const _hoisted_4 = { class: "flex-container" }
const _hoisted_5 = { class: "table-wrapper" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Jobs", -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "table-wrapper" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Tasks", -1))
const _hoisted_10 = { key: 0 }

import TaskList from '@/components/TaskList.vue';
import JobList from '@/components/JobList.vue';
import PieChartComponent from '@/components/PieChartComponent.vue';
import { useEmployeeStore } from '@/stores/UserEmployee';
import { useJobStore } from '@/stores/Jobs';
import { useTaskStore } from '@/stores/Tasks'
import { storeToRefs } from 'pinia';
import { watch, computed, onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AdminDashBoard',
  setup(__props) {

const employeeStore = useEmployeeStore();
const jobStore = useJobStore();
const taskStore = useTaskStore();
const { all_jobs, isLoadingJobs } = storeToRefs(jobStore);
const { all_tasks, isLoadingTaks } = storeToRefs(taskStore);


const getUserById = (userId: number) => {
  const user = employeeStore.getById(userId);
  return user ? user : { id: userId, username: `User ${userId}` };
};

function truncateMilliseconds(durationStr) {
  return durationStr.split('.')[0];
}

onMounted(() => {
  jobStore.getAllJobs();
  taskStore.getAllTasks()
});

watch(all_tasks, (newTasks) => {
  if (newTasks) {
    // You can perform additional actions here if needed,
    // such as logging or handling the data differently.
  }
}, { immediate: true });

watch(all_jobs, (newTasks) => {
  if (newTasks) {
    // You can perform additional actions here if needed,
    // such as logging or handling the data differently.
  }
}, { immediate: true });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", null, [
        _createVNode(PieChartComponent),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            (_unref(isLoadingJobs))
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Loading Jobs..."))
              : (_openBlock(), _createBlock(JobList, {
                  key: 1,
                  jobs: _unref(all_jobs),
                  "visible-columns": ['id', 'name', 'total_active_duration', 'total_cost']
                }, null, 8, ["jobs"]))
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            (_unref(isLoadingTaks))
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, "Loading Tasks..."))
              : (_openBlock(), _createBlock(TaskList, {
                  key: 1,
                  tasks: _unref(all_tasks),
                  "visible-columns": ['id', 'name', 'job_name', 'total_active_duration', 'labor_cost', 'assigned']
                }, null, 8, ["tasks"]))
          ])
        ])
      ])
    ])
  ]))
}
}

})